import type { CSSProperties, FC } from 'react';
import styles from './Divider.module.css';

type Props = {
    width: CSSProperties['width'];
};

export const Divider: FC<Props> = ({ width }) => (
    <div className={styles.divider} style={{ width }} />
);
